import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import 'moment/locale/ru';

import { checkDelivered } from '../../../../helpers';

import { INFO_STATUS_BAR_TRANSLATE } from '../../../../config';
import { badgesStyle } from '../../../../config';

moment.locale('ru');

const Wrapper = styled('div')`
  padding: 28px 16px 16px;
  margin: 0 -22px;
  position: relative;

  .back-link {
    color: inherit;
    position: absolute;
    font-size: 16px;
    right: 16px;
    top: 15px;
    line-height: 100%;
  }

  .page-title {
    margin: 0 0 5px;
  }

  .header-date {
    margin-bottom: 10px;
  }

  .badges-wrapper {
    display: flex;
    flex-wrap: wrap;
  }

  .status-badge,
  .payment-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 3px 10px 3px 0;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background: #ccc;
    border: 1px solid #fff;
    color: #296775;
    padding: 2px 8px 0;
    min-width: 80px;
    text-align: center;
    height: 19px;

    i {
      font-size: 12px;
      margin-top: -2px;
    }
  }
  .status-badge-wrapper {
    position: relative;
  }
  .status-badge-tip {
    position: absolute;
    z-index: 100;
    background: white;
    padding: 5px 10px;
    border-radius: 3px;
    width: 150px;
    border: 1px solid #ebebeb;
    top: 25px;
    left: 8px;
  }
`;

const MobileHeeader = (props) => {
  const { history, isNew, currentOrder, PaymentBadge } = props;

  const customBackLink = history.location.state && history.location.state.customBackLink;

  const pageTitle = isNew ? 'Новый заказ' : currentOrder ? currentOrder.id : '';
  const breadcrumbs = [
    {
      title: 'Заказы',
      route: customBackLink ? customBackLink : '/orders',
    },
    { title: pageTitle },
  ];

  const [tip, changeTip] = useState(false);

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle + ' — Кактус';
    }
  }, [pageTitle]);

  return (
    <Wrapper>
      <h4 className="page-title">{pageTitle}</h4>
      <Link className="back-link" to={breadcrumbs[breadcrumbs.length - 2].route}>
        <i className="fe-x" />
      </Link>
      {!isNew ? (
        <>
          <div className="header-date">
            {moment(currentOrder.date).format('DD MMM YYYY HH:mm:SS')}
          </div>
          <div className="badges-wrapper">
            <div className="status-badge-wrapper" onClick={() => changeTip(!tip)}>
              {currentOrder.status !== 'ORDER_INFO_REQUIRE_PAYMENT' ? (
                <div className="status-badge" style={badgesStyle[currentOrder.status]}>
                  {INFO_STATUS_BAR_TRANSLATE[currentOrder.status]}
                  {` `}
                  {currentOrder.delivery?.actualDeliveryDate && checkDelivered(currentOrder.status)
                    ? moment(currentOrder.delivery?.actualDeliveryDate).format(`DD.MM.YYYY`)
                    : null}
                </div>
              ) : null}
              {tip && currentOrder.repeatConfirmationDate && (
                <div className="status-badge-tip">
                  Время звонка: <br />{' '}
                  <strong>
                    {moment(currentOrder.repeatConfirmationDate).format('DD-MM-YYYY HH:mm:ss')}
                  </strong>
                </div>
              )}
            </div>
            <PaymentBadge {...currentOrder} mobile noSubtitle={true} />
          </div>
        </>
      ) : null}
    </Wrapper>
  );
};

export default MobileHeeader;
